<template>
  <div class="content">
    <!-- <img src="/static/yuandan/bg.png" class="index_bg"/> -->
    <img src="/static/yuandan/bg.png" class="index_bg" />
    <div class="bag_v">
      <div class="bag1 bags">
        <img src="/static/yuandan/bags.png" mode="" class="bagl" />
        <img src="/static/yuandan/bag.png" mode="" class="bag" />
      </div>
      <div class="bag2 bags">
        <img src="/static/yuandan/bags.png" mode="" class="bagl" />
        <img src="/static/yuandan/bag.png" mode="" class="bag" />
      </div>
      <div class="bag3 bags">
        <img src="/static/yuandan/bags.png" mode="" class="bagl" />
        <img src="/static/yuandan/bag.png" mode="" class="bag" />
      </div>
      <div class="bag4 bags">
        <img src="/static/yuandan/bags.png" mode="" class="bagl" />
        <img src="/static/yuandan/bag.png" mode="" class="bag" />
      </div>
    </div>
    <div class="c_body">
      <div class="rule_reword">
        <div class="rr_c flex_c" @click="show_rule_f">
          <!-- <img :src="img_path+'fanhu.png'" class="fanfu"/> -->
          <span>规则</span>
        </div>
        <div class="rr_c flex_c" @click="show_reword_f">
          <!-- <img :src="img_path+'fanhu.png'" class="fanfu"/> -->
          <span>奖品</span>
        </div>
        <div class="rr_c flex_c" @click="click_beposter">海报</div>
      </div>
      <div class="yezi_v">
        <img
          :src="img_path + 'yezix.png'"
          class="yeziimg"
          v-if="yezi_status == 1"
        />
        <img
          :src="img_path + 'yezi2x.png'"
          class="yeziimg"
          v-else-if="yezi_status == 2"
        />
      </div>
      <div class="cd_koala">
        <img
          :src="img_path + 'kaolax.png'"
          class="koalaimg"
          mode=""
          :style="koala_top"
        />
      </div>
      <div class="cb_btn">
        <!-- <img :src="img_path+'shoux.png'" class="img"/> -->
        <img src="/static/yuandan/btn.png" class="img" />
        <img src="/static/yuandan/hand.png" class="hand" mode="" />
        <div class="cbb_text" @click="koala_go">狂戳我,帮考拉上树</div>
      </div>
      <div class="cb_textf">
        <div class="cbb_text1">
          您还有 <span class="yellow">{{ ld_count }}</span> 次抽奖机会
        </div>
        <div>
          (距活动结束还剩<span>{{ time_down }}</span
          >)
        </div>

        <div class="cbb_text1" style="margin: 16upx 0 0" v-show="usercount">
          当前账户：{{ usercount }}
        </div>
        <div class="cbb_text1" v-show="usercount">
          如果您想切换账号，请<span class="yellow bot" @click="change_account"
            >点击这里</span
          >
        </div>
      </div>
    </div>
    <div class="c_foot">
      <img src="/static/yuandan/foter-img.png" mode="" class="img" />
    </div>
    <!-- 活动规则 -->
    <div class="window" v-if="show_rule">
      <div class="w_content">
        <img src="/static/yuandan/guize.png" class="guize" />
        <div class="guize_text">
          <div class="p1">
            凡在考拉知道完成试听的用户，均享受免费抽奖资格，100%中奖！请注意：
          </div>
          <div>1、如您已完成试听，登录后即可抽奖。</div>
          <div>2、如您还没注册，马上注册并完成试听，即可抽奖。</div>
          <div>
            3、如您已注册，还未试听，马上联系专属顾问为您服务，试听后即可抽奖。
          </div>
          <div>{{rule_four}}</div>
          <div class="p2">本次活动的最终解释权归考拉知道所有</div>
        </div>
        <img
          :src="img_path + 'guanbis.png'"
          class="guanbi"
          mode=""
          @click="hide_win"
        />
      </div>
    </div>
    <!-- 活动规则 end-->
    <!-- 奖品弹窗 -->
    <div class="window w_rew" v-show="show_reword">
      <div class="w_content">
        <img
          src="/static/yuandan/jiangs.png"
          class="jiangpinx"
          mode=""
          v-if="ld_count == 3"
        />
        <img src="/static/yuandan/jiang.png" class="jiangpinx" mode="" v-else />

        <div class="reword_list">
          <div v-for="(item, index) in reword_list" :key="index">
            <div class="rl_li" v-if="item.luckDrawType != 'enyGanXie'">
              {{ item.luckDrawValue }}
              <div class="samll" v-if="item.luckDrawType == 'enyDaiJinJuan'">有效期至：{{ times(item.addTime) }}</div>
            </div>
          </div>
          <div class="rl_li" v-if="reword_list.length == 0">暂无获奖记录</div>

          <div
            class="wr_text"
            :style="reword_list.length < 2 ? 'margin: 80px 0 0' : ''"
          >
            <div>请在个人账户中查看。</div>
            <div>如有问题，请随时联系您的专属顾问或班主任。</div>
          </div>
        </div>
        <img
          :src="img_path + 'guanbis.png'"
          class="guanbi"
          mode=""
          @click="hide_win"
        />
      </div>
    </div>
    <!-- 奖品弹窗 end-->
    <!-- 活动已结束 -->
    <div class="window" v-show="huodong_end">
      <div class="end">活动已结束！</div>
    </div>
    <!-- 活动已结束 end-->
    <!-- 抽到奖品的弹窗 -->
    <div class="window" v-if="have_win">
      <div class="w_content choujiang" v-if="ld_true">
        <img :src="img_path + 'zhingjiangx.png'" class="img" />
        <div class="cj_content">
          <div>WOW!你手气太好！</div>
          <div>
            {{ ld_text.indexOf("中文课") > 0 ? ld_text : "USD" + ld_text }}
          </div>
          <!-- <div>20代金券</div> -->
          <div>已到账！</div>
          <!-- <div class="end_time">有效期至：{{ qet_time }}</div> -->
        </div>
        <img
          :src="img_path + 'guanbi.png'"
          class="close"
          mode=""
          @click="zhanshi_poster"
        />
      </div>
      <div class="w_content choujiang" v-else>
        <img src="/static/yuandan/no_jiang.png" class="img" />
        <img
          :src="img_path + 'guanbi.png'"
          class="close"
          mode=""
          @click="hide_win"
        />
      </div>
    </div>
    <!-- 抽到奖品的弹窗 end-->
    <!-- 转发海报 -->
    <div class="window" v-show="show_poster">
      <div class="w_content">
        <!-- <img :src="poster_url" mode="" class="poster_img"/> -->
        <div class="poster_img">
          <img
            :src="poster_url"
            mode=""
            class="poster_img"
            v-if="poster_url"
            id="poster_img"
          />
        </div>
        <div class="p_btn" v-if="is_wx || !is_android">
          <div class="p1">长按图片,保存海报</div>
          <div class="p2">转发朋友圈,邀请还能再得最高4节赠课!</div>
        </div>
        <!-- <div class="p_btn" @click="down_posters" v-else-if="!is_android&&!is_wx">
					<div class="p1">查看海报，长按保存海报</div>
					<div class="p2">转发朋友圈,邀请还能再得最高4节赠课!</div>
				</div> -->
        <div class="p_btn" @click="down_posters" v-else>
          <div class="p1">点击按钮，保存海报</div>
          <div class="p2">转发朋友圈,邀请还能再得最高4节赠课!</div>
        </div>
        <div class="p_btn" v-if="is_wx" @click="iswx_tap">
          <div class="p1">直接转发给亲友</div>
          <div class="p2">邀请还能再得最高4节赠课!</div>
        </div>
        <img
          :src="img_path + 'guanbi.png'"
          class="close close_p"
          mode=""
          @click="hide_win"
        />
      </div>
    </div>
    <!-- <canvas canvas-id="mycanvas" style="width:300upx;height:300upx;"></canvas> -->
    <div style="position: fixed; right: 100vw">
      <!-- <canvas canvas-id="poster" :style="'width:'+canvas_w+'upx;height:'+canvas_h+'upx;'"></canvas> -->
      <canvas
        canvas-id="poster_imgc"
        id="poster_imgc"
        style="width: 750px; height: 1334px"
      ></canvas>
    </div>
    <!-- 转发海报 end-->
    <!-- weixin专属分享弹窗 -->
    <div class="window wx_win" v-if="is_wx_show" @click="hide_wx_sha">
      <div class="w_content">
        <img class="share_icon" src="/static/yuandan/share.png" />
        <div class="p1">立即分享给好友吧</div>
        <div class="p2">点击屏幕右上角将本页分享给好友</div>
      </div>
    </div>
    <!-- weixin专属分享弹窗 end-->
    <Login
      :code_list="code_list"
      v-if="login_s"
      @register="register"
      @close="hide_win"
      @havelogin="havelogin"
    />
    <Register
      :code_list="code_list"
      :fromuid="fromuid"
      appid="2020抽奖"
      v-if="register_s"
      @login="login"
      @close="hide_win"
      @haveregister="haveregister"
    />
    <!-- 测试 -->
    <div class="window" style="display: none">
      <div id="qrcode" style="display: none"></div>
      <canvas id="mycanvas2" style="display: none"></canvas>
      <img :src="haibao" />
    </div>
    <!-- 顾问二维码 -->
    <div class="window guwen" v-if="hide_guwen">
      <div class="w_content">
        <div class="c">
          <img :src="guwenimg" mode="" class="img" />
          <div>
            您还没有完成试听，不能抽奖哦！马上联系专属顾问试听，100%大奖等着您！
          </div>
        </div>
        <img
          :src="img_path + 'guanbi.png'"
          class="close close_p"
          mode=""
          @tap="hide_win"
        />
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../service/http";

// import '../../js_sdk/ican-H5Api/ican-H5Api.js'
// import FileSaver from 'file-saver';

import Login from "../../common/login/login";
import Register from "../../common/register/register";
import { Dialog, Loading } from "vant";
export default {
  components: {
    Login,
    Register,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
  },
  data() {
    return {
      img_path: "https://www.koalaknow.com/img/register/exchangeenter/", //图片域名
      yezi_status: 0, //展示哪个叶子
      show_rule: false, //展示规则
      show_reword: false, //展示奖品
      reword_list: [], //获得的奖品的列表
      time_down: "", //倒计时
      huodong_end: false, //活动已结束
      koala_top: "bottom:0",
      koala_topnum: 0,
      code_list: [], //国家区号列表
      login_s: false, //展示登录
      register_s: false, //展示注册
      ld_text: "", //活得奖励的名称
      ld_true: true, //中了奖
      have_win: false, //获得奖品的弹窗
      ld_count: "", //还剩几次抽奖次数
      canvas_h: "",
      canvas_w: "",
      show_poster: false, //展示海报
      poster_url: "", //海报路径
      fromuid: "", //进入页面链接拼接了uid
      is_wx_show: false, //当前在微信环境中，且，触发分享
      is_wx: false, //当前打开环境是微信
      is_chouing: true, //当前正在抽奖，禁止重复提交
      is_android: false, //当前系统是安卓
      usercount: "", //当前用户账号
      qet_time: "",
      haibao: "",
      guwenimg: "", //未试听用户顾问二维码地址,
      hide_guwen: false,
      rule_four:'4、请于北京时间2021年1月1日16:00:00至2月1日14:59:59进行抽奖，逾期无效。奖品实时到账，可在考拉知道个人账户查看。如有问题，可联系您的专属顾问或班主任。'
    };
  },
  mounted() {
    this.onolad_s();
    document.title = '考拉知道新年接福大乐透';
    // this.func_posters();
  },
  methods: {
    times(e) {
      //设置代金券有效期
      e=e.replace(/-/g,'/');
      var date = Date.parse(e) + 2592000000;
      return http.timestampToTime(date);
      // that.qet_time=http.timestampToTime(date);
    },
    //onload()
    onolad_s() {
      var userinfo = localStorage.getItem("userinfo");
      this.canvas_h = window.screen.height * 4;
      this.canvas_w = window.screen.width * 4;

      this.count_down_time();
      this.get_DrawCount();
      this.get_codelist();
      if (http.getIsWxClient()) {
        this.is_wx = true;
      }
      // this.get_codeimg(8537);
      //自定义分享
      var imgUrl = "https://www.koalaknow.com/img/VcharImg/vcharlogo.png"; // 分享图标
      var title = "考拉知道｜新年接福大乐透",
        desc = "全球华裔少儿抽奖接福，100%中奖赢中文大礼包！";
    var endtime1=1612162799000;
    var now = http.now();
    var dis1 = endtime1 - now;
    if(dis1<0){
title = "考拉知道｜新春接福大乐透"
    }
      if (userinfo) {
        userinfo = JSON.parse(userinfo);
        this.usercount = userinfo.userAccount || userinfo.loginName;
        http.wxshare(
          userinfo.userId,
          "https://official.koalaknow.com?uid=" + userinfo.userId,
          title,
          desc,
          imgUrl
        );
        this.poster_url =
          "https://crm.koalaknow.com/OldTmkUser/SetUserPosterImgActiveUID?uid=" +
          userinfo.userId +
          "&userPosterTemplateImgUrl=/UploadFile/2021/01/04/20952566-0052-43b4-b495-4ffed37190f9.png&userPosterTemplatePoint=586,1138,132,132";
        // http.createQrCode(
        //   "https://official.koalaknow.com/?uid=" + userinfo.userId
        //   // "https://official.koalaknow.com/?uid=" + 24129
        // );

        // var qrcode=document.getElementById('qrcode')
        // this.$qr.getCode(qrcode, 132, 132, 'https://official.koalaknow.com/?uid='+ userinfo.userId);
      } else {
        http.wxshare("", "https://official.koalaknow.com", title, desc, imgUrl);
      }
      var url_uid = http.getQueryString("uid");
      if (url_uid) {
        this.fromuid = url_uid;
      }
      if (http.SystemInfo().platform == "android") {
        this.is_android = true;
      }
    },
    //倒计时
    count_down_time() {
      var endtime = 1612162799000;
      var endtime1=1614527999000;
      var that = this;
      var now = http.now();
      var timeflag = setTimeout(function () {
        var dis = endtime - now;
        var dis1 = endtime1 - now;
        if (dis > 0) {
          var dis_s = dis / 1000;
          var day = Math.floor(dis_s / 60 / 60 / 24);
          dis_s = dis_s - day * 24 * 60 * 60;
          var hour = Math.floor(dis_s / 60 / 60);
          hour = hour > 9 ? hour : "0" + hour;
          dis_s = dis_s - hour * 60 * 60;
          var minute = Math.floor(dis_s / 60);
          minute = minute > 9 ? minute : "0" + minute;
          var second = parseInt(dis_s - minute * 60);
          second = second > 9 ? second : "0" + second;
          that.time_down = day + "天 " + hour + ":" + minute + ":" + second;
          now = now + 1000;
          if (now > 1000) {
            that.count_down_time(now);
          } else {
            clearTimeout(timeflag);
          }
        } else if (dis1 > 0) {
          var dis_s = dis1 / 1000;
          var day = Math.floor(dis_s / 60 / 60 / 24);
          dis_s = dis_s - day * 24 * 60 * 60;
          var hour = Math.floor(dis_s / 60 / 60);
          hour = hour > 9 ? hour : "0" + hour;
          dis_s = dis_s - hour * 60 * 60;
          var minute = Math.floor(dis_s / 60);
          minute = minute > 9 ? minute : "0" + minute;
          var second = parseInt(dis_s - minute * 60);
          second = second > 9 ? second : "0" + second;
          that.time_down = day + "天 " + hour + ":" + minute + ":" + second;
          now = now + 1000;
          that.rule_four='4、请务必于北京时间 2021 年 2 月 1 日 00:00:00 至 2 月 28 日 23:59:59 完成抽奖，逾期作废。奖品实时到账，可在考拉知道个人账户查看。如有问题，可联系您的专属顾问。'
          if (now > 1000) {
            that.count_down_time(now);
          } else {
            clearTimeout(timeflag);
          }
        }else {
          that.huodong_end = true;
        }
      }, 1000);
    },
    //获取还剩几次抽奖次数
    get_DrawCount() {
      var userinfo = localStorage.getItem("userinfo"),
        that = this;
      if (userinfo) {
        userinfo = JSON.parse(userinfo);
        var data = {
          cmd: "GetUserLuckDrawCount",
          userGuid: userinfo.userGuid,
        };
        http.req(data, function (res) {
          that.ld_count = 3 - res.userLuckDrawLogCount;
        });
      } else {
        that.ld_count = 3;
      }
    },
    //考拉上树
    koala_go() {
      var userinfo = localStorage.getItem("userinfo");
      if (http.now() < 1609488000000) {
        Dialog.alert({
          title: "活动还未开始哦！",
          showConfirmButton: false,
          closeOnClickOverlay: true,
          className: "Dialog",
          overlayStyle: { background: "transparent" },
        });
      } else if (
        localStorage.getItem("isshiting") == "noshiting" &&
        localStorage.getItem("iszhifu") == "nozhifu"
      ) {
        this.hide_guwen = true;
        this.guwenimg = JSON.parse(userinfo).saleWechatImg;
        // Dialog.alert({
        //   title:
        //     "您还没有完成试听，不能抽奖哦！马上联系专属顾问试听，100%大奖等着您！",
        //   showConfirmButton: false,
        //   closeOnClickOverlay: true,
        //   className: "Dialog",
        //   overlayStyle: { background: "transparent" },
        // });
        // setTimeout(() => {
        //   $(".Dialog,.van-overlay").remove();
        // }, 2000);
      } else if (this.ld_count == 0) {
        Dialog.alert({
          title: "3次抽奖已结束，运气真是太棒啦！",
          showConfirmButton: false,
          closeOnClickOverlay: true,
          className: "Dialog",
          overlayStyle: { background: "transparent" },
        });
        setTimeout(() => {
          $(".Dialog,.van-overlay").remove();
        }, 2000);
      } else if (userinfo) {
        if (this.koala_topnum < 137.5) {
          this.koala_topnum += 7.5;
          this.koala_top = "bottom:" + this.koala_topnum + "px;";
          var yezi_status = this.yezi_status;
          this.yezi_status = yezi_status == 0 || yezi_status == 2 ? 1 : 2;
        } else if (this.is_chouing) {
          this.is_chouing = false;
          this.koala_top = "bottom:137.5px;transform:rotate(20deg)";
          this.func_LuckDraw(JSON.parse(userinfo));
        }
        console.log(this.koala_top);
        this.$forceUpdate();
      } else {
        this.login_s = true;
      }
    },
    //执行抽奖函数
    func_LuckDraw(userinfo) {
      var data = {
          cmd: "UserLuckDraw2021",
          userGuid: userinfo.userGuid,
        },
        that = this;
      http.req(data, function (res) {
        that.is_chouing = true;
        if (res.flag != 1) {
          Dialog.alert({
            title: res.msg,
            showConfirmButton: false,
            closeOnClickOverlay: true,
            className: "Dialog",
            overlayStyle: { background: "transparent" },
          });
          setTimeout(() => {
            $(".Dialog,.van-overlay").remove();
          }, 2000);
        } else if (res.luckDrawType == "enyGanXie") {
          that.have_win = true;
          that.ld_true = false;
        } else {
          //设置代金券有效期
          var date = http.now() + 2592000000;
          that.qet_time = http.timestampToTime(date);
          that.have_win = true;
          that.ld_true = true;
          that.ld_text = res.luckDrawValue;
        }
        that.get_DrawCount();
      });
    },
    //获取国家区号列表
    get_codelist() {
      var data = {
          cmd: "GetCountryList",
          orderType: "default",
        },
        that = this;
      http.req(data, function (res) {
        that.code_list = res.list;
      });
    },
    //点击去注册
    register(e) {
      this.login_s = false;
      this.register_s = true;
    },
    //去登陆
    login() {
      this.login_s = true;
      this.register_s = false;
    },
    //关闭登录和注册以及各个弹窗
    hide_win() {
      this.login_s = false;
      this.register_s = false;
      this.show_rule = false;
      this.show_reword = false;
      this.have_win = false;
      this.show_poster = false;
      this.is_wx_show = false;
      this.ld_text = "";
      this.koala_topnum = 0;
      this.koala_top = "bottom:0upx";
      // uni.hideToast();
    },
    //查看规则
    show_rule_f() {
      this.show_rule = true;

      // this.zhanshi_poster()
    },
    //查看奖品
    show_reword_f() {
      this.show_reword = true;
      var userinfo = localStorage.getItem("userinfo");
      if (userinfo) {
        var that = this;
        var data = {
          cmd: "GetUserLuckDrawLogList",
          userGuid: JSON.parse(userinfo).userGuid,
        };
        http.req(data, function (res) {
          if (res.list[0].luckDrawType == "enyGanXie" && res.list.length == 1) {
            that.reword_list = [];
          } else {
            that.reword_list = res.list;
          }
        });
      } else {
        this.reword_list = [];
      }
    },
    zhanshi_poster() {
      Dialog.alert({
        message: "<van-loading vertical>正在生成海报...</van-loading>",
        showConfirmButton: false,
        closeOnClickOverlay: true,
        className: "Dialog",
        allowHtml: true,
        overlayStyle: { background: "transparent" },
      });
      setTimeout(() => {
        $(".Dialog,.van-overlay").remove();
      }, 2000);
      // var userinfo = localStorage.getItem("userinfo");
      // userinfo = JSON.parse(userinfo);
      // var that = this;

      // var aaa = setInterval(() => {
      //   var c = $("#qrcode")[0].lastChild;
      //   if (c) {
      //     that.savehaibaoimgs(
      //       "https://official.koalaknow.com/?uid=" + userinfo.userId
      //       // "https://official.koalaknow.com/?uid=" + 25730
      //     );
      //     clearInterval(aaa);
      //   }
      // }, 500);

      //   this.savehaibaoimgs(localStorage.getItem("codeimg"));
      this.have_win = false;
      this.show_poster = true;
    },
    //绘制海报
    savehaibaoimgs(url) {
      console.log(url);
      // http.createQrCode(url);
      let t = this;
      let c = document.getElementById("mycanvas2"); // 画板id
      c.width = 750;
      c.height = 1334;
      let ctx = c.getContext("2d");
      let img = new Image(); // 背景图对象
      img.onload = function () {
        ctx.drawImage(img, 0, 0); // 背景图载入画板
        ctx.drawImage($("#qrcode")[0].lastChild, 586, 1138); // 二维码图载入画板  后面是定位参数
      };
      img.src = "/static/yuandan/haibaox.png"; // 背景图路经
      var imgage = new Image();
      setTimeout(function () {
        t.poster_url = c.toDataURL("image/png");
      }, 1000);
    },
    savehaibaoimg(img) {
      var that = this;
      setTimeout(function () {
        // var ctx = uni.createCanvasContext('poster_imgc');
        var ctx = document.getElementById("poster_imgc");
        ctx = ctx.getContext("2d");
        ctx.fillRect(0, 0, 750, 1334);
        ctx.drawimg("/static/yuandan/haibaox.png", 0, 0, 750, 1334);
        ctx.drawimg(img, 590, 1145, 130, 130);
        ctx.draw(
          true,
          setTimeout(function () {
            that.huizhi();
          }, 1000)
        );
      }, 1500);
    },
    //保存海报
    huizhi() {
      var that = this;
      uni.canvasToTempFilePath({
        canvasId: "poster_imgc",
        quality: 1,
        success: function (res) {
          that.poster_url = res.tempFilePath;
          $(".Dialog").hide();
        },
        fail: function (res) {
          console.log("bbb", res);
        },
      });
    },
    //登录成功
    havelogin() {
      Dialog.alert({
        message: "登录成功,狂戳帮考拉上树吧！",
        showConfirmButton: false,
        closeOnClickOverlay: true,
        className: "Dialog",
        allowHtml: true,
        overlayStyle: { background: "transparent" },
      });
      setTimeout(() => {
        $(".Dialog,.van-overlay").remove();
      }, 2000);
      this.login_s = false;
      this.register_s = false;
      this.onolad_s();
    },
    //注册成功
    haveregister() {
      Dialog.alert({
        message: "注册成功,狂戳帮考拉上树吧！",
        showConfirmButton: false,
        closeOnClickOverlay: true,
        className: "Dialog",
        allowHtml: true,
        overlayStyle: { background: "transparent" },
      });
      setTimeout(() => {
        $(".Dialog,.van-overlay").remove();
      }, 2000);
      this.login_s = false;
      this.register_s = false;
      this.onolad_s();
    },

    //获取海报上的二维码
    get_codeimg(uid) {
      http.be_poster("https://official.koalaknow.com?uid=" + uid);
    },
    //展示提示转发的弹窗
    iswx_tap() {
      this.is_wx_show = true;
    },
    //隐藏展示提示转发的弹窗
    hide_wx_sha() {
      this.is_wx_show = false;
    },
    //微信环境外保存海报
    down_posters() {
      var img = $("#poster_img");
      // 将图片的src属性作为URL地址
      var url = img.attr("src");
      var a = document.createElement("a");
      var event = new MouseEvent("click");

      a.download = "分享海报";
      a.href = url;

      a.dispatchEvent(event);
      //   var that = this;
      //   console.log(that.poster_url);
      //   uni.saveVideoToPhotosAlbum({
      //     filePath: that.poster_url,
      //     success: function () {
      //       console.log("save success");
      //     },
      //   });
    },
    //点击切账号
    change_account() {
      this.login_s = true;
    },
    //点击页面右侧生成海报
    click_beposter() {
      console.log("bbb");
      if (localStorage.getItem("userinfo")) {
        this.zhanshi_poster();
      } else {
        this.change_account();
      }
    },
  },
};
</script>
<style scoped>
/* @import url("index.css"); */
.content {
  width: 100vw;
  /* height: 100vh; */
  /* height: 1338px; */
  position: relative;
  overflow-x: hidden;
}

.index_bg {
  width: 100%;
  /* height: 1409px; */
  background: linear-gradient(0deg, #65abe7, #9ee1fe, #d5f5e6);
  /* object-fit: cover; */
}

.content .c_body {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 1334px;
  top: 0;
  left: 0;
  text-align: center;
}

.rule_reword {
  position: absolute;
  right: -10px;
  top: 305px;
  font-size: 26px;
  color: #fff;
  z-index: 2;
}

.rule_reword .rr_c {
  width: 76px;
  height: 100px;
  background: #f6bb3d;
  border: 3px solid #ffffff;
  border-radius: 15px;
  padding: 2px 6px 0;
  box-sizing: border-box;
  margin: 29px 0 0;
}

.c_foot {
  /* border-top: 4px solid #E50012; */
  text-align: center;
  padding: 16px 0;
  box-sizing: border-box;
}

.c_foot .img {
  width: 564px;
  height: 148px;
}

.yezi_v {
  height: 290px;
  margin: 400px auto 0;
}

.yezi_v .yeziimg {
  width: 351px;
  height: 290px;
}

.cd_koala {
  position: relative;
  height: 436px;
}

.cd_koala .koalaimg {
  position: absolute;
  width: 125px;
  height: 148px;
  left: 34%;
}

.cb_btn {
  position: relative;
  width: 354px;
  margin: 0 auto;
}

.cb_btn .img {
  width: 354px;
  height: 106px;
}

.cb_btn .hand {
  width: 76px;
  /* height: 92px; */
  position: absolute;
  z-index: 2;
  right: 0px;
  top: 60px;
  animation: hand 500ms infinite;
  -webkit-animation: hand 500ms infinite;
}

@keyframes hand {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.1);
  }
}
@-webkit-keyframes name {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.1);
  }
}

.cb_btn .cbb_text,
.cb_btn .cbb_text1 {
  position: absolute;
  width: 100%;
}

.cb_btn .cbb_text {
  font-size: 34px;
  color: #f14b08;
  font-weight: bold;
  top: 0;
  height: 100px;
  padding: 24px 0 0 0;
  width: 400px;
  left: 50%;
  transform: translateX(-50%);
}

.cbb_text1 {
  color: #fff;
  bottom: 0;
  font-size: 24px;
}
.cbb_text1 .bot {
  border-bottom: 1px solid currentcolor;
}

.cb_textf {
  font-size: 22px;
  color: #d9fbc9;
  margin: 4px 0 0 0;
}

.window .guize {
  width: 608px;
  height: 720px;
}

.window .guize_text {
  color: #b87b4c;
  font-size: 24px;
  line-height: 40px;
  position: absolute;
  top: 192px;
  padding: 0 118px;
  box-sizing: border-box;
}
.window .guize_text .p1 {
  margin: 0 0 11px 0;
}
.window .guize_text .p2 {
  font-size: 24px;
  transform: scale(0.75);
  text-align: center;
  margin: 20px 0 0;
}

.window .guanbi {
  width: 80px;
  height: 80px;
  margin: 118px auto 0;
}

.window .w_content .jiangpinx {
  width: 691px;
  height: 856px;
}

.w_rew {
  text-align: center;
}

.w_content .reword_list {
  position: absolute;
  width: 600px;
  height: 340px;
  overflow-y: scroll;
  top: 440px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 38px;
  line-height: 60px;
  font-weight: bold;
}

.w_content .reword_list .rl_li {
  margin: 3px 0;
  color: #ffff00;
  /* height: 120px; */
}

.w_content .wr_text {
  color: #fff371;
  font-size: 24px;
  line-height: 30px;
  /* position: absolute; */
  /* top: 840px; */
  width: 100%;
  transform: scale(0.9);
  margin: 34px 0 0 12px;
  position: absolute;
  bottom: 0;
}

.end {
  line-height: 80vh;
  text-align: center;
  color: #fff;
  font-size: 30px;
}

.choujiang .img {
  width: 729px;
  height: 811px;
}

.choujiang .cj_content {
  position: absolute;
  font-size: 54px;
  color: #fff2b3;
  top: 315px;
  width: 100%;
  text-align: center;
  font-weight: bold;
}
.choujiang .cj_content .end_time {
  font-size: 28px;
  font-weight: normal;
}
.window .close {
  width: 80px;
  height: 80px;
}

.yellow {
  color: #fba220;
  font-weight: bold;
  margin: 0 4px;
}

.poster_img {
  width: 487px;
  height: 867px;
  margin: 0 auto;
}

.window .p_btn {
  width: 600px;
  height: 82px;
  background: #ff8a00;
  border-radius: 41px;
  color: #fff;
  margin: 21px auto 0;
  text-align: center;
  padding: 10px 0 0;
  box-sizing: border-box;
}

.w_content .p_btn .p1 {
  font-size: 28px;
  line-height: 30px;
}

.w_content .p_btn .p2 {
  font-size: 20px;
}

.close_p {
  margin: 20px auto 0;
}

.wx_win .share_icon {
  position: absolute;
  width: 64px;
  height: 56px;
  right: 30px;
  top: 30px;
}

.wx_win .p1 {
  font-size: 48px;
  margin: 300px 0 10px 0;
}

.wx_win .w_content {
  color: #fff;
  text-align: center;
  font-size: 28px;
  top: 0;
  transform: translate(-50%, 0%);
  position: absolute;
  width: 100%;
}
.bag_v {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.bag_v .bags {
  position: relative;
}
.bag_v .bag1,
.bag_v .bag2,
.bag_v .bag3 {
  width: 185px;
  height: 184px;
}
.bag_v .bags .bagl {
  width: 100%;
  height: 100%;
  animation: light 800ms infinite;
  -webkitanimation: light 800ms infinite;
}
@keyframes light {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes name {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.bag_v .bag1 .bag,
.bag_v .bag2 .bag,
.bag_v .bag3 .bag {
  width: 65px;
  height: 157px;
}
.bag_v .bag {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bag_v .bag4 {
  width: 307px;
  height: 305px;
}
.bag_v .bag4 .bag {
  width: 108px;
  height: 261px;
}
.bag_v .bag1 {
  left: 64px;
  top: 482px;
}
.bag_v .bag2 {
  left: 548px;
  top: 390px;
}
.bag_v .bag3 {
  left: 114px;
  top: 418px;
}
.bag_v .bag4 {
  top: 130px;
  left: 378px;
}
.samll {
  font-size: 24px;
  font-weight: normal;
}
.guwen .w_content .img {
  width: 400px;
  height: 400px;
  margin: 30px auto;
}
.guwen .w_content .c {
  font-size: 28px;
  background: #fff;
  line-height: 40px;
  width: 90%;
  text-align: center;
  border-radius: 20px;
  padding: 50px 32px;
  box-sizing: border-box;
  margin: 0 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/content/index/index.vue